<li>
  <a (click)="scrollToElement()">{{ heading }}</a>
</li>
